import React from 'react'
import LeftBar from '../LeftBar/LeftBar copy'
import img_about from 'assets/img/JPE_about.png';
import GLIFOS_poweredby from 'assets/img/GLIFOS_poweredby.png';
import MEDIAWIKI_poweredby from 'assets/img/MEDIAWIKI_poweredby.png';
import cc_img from 'assets/img/cc_info.png';
import styles from './GeneralLeftBar.module.scss'
import RightBar from '../RightBar/RightBar';
import {journalLinks, additionalInfoLinks,authorsLink,thisIssueLinks} from '../MainPageLeftBar/dumpBarInfo';
import {useLastNewsPage} from '../../hooks/useThisIssuePage';
import ThisIssue from '../ThisIssue/ThisIssue';

export default function GeneralLeftBar(props) {
    const {startCollapse} = props;
    //const {isLoading, isError, payload, error} = useLastNewsPage();
    return (
        <>

            <div className=''>
                <ThisIssue mainPage={false} 
                    startCollapse={startCollapse}
                />
                {/* {
                    !isError && !isLoading && payload && (
                        <RightBar details={payload} />
                    )
                } */}
            </div>
            <div className='my-4'>
                <LeftBar title="Previous Journal Issues" links={journalLinks} />
            </div>
        </>
    )
}
